import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Credly|Management|Search|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

type LocNameStart = 'SPCredlyManagementSearchForm';
export type SPCredlyManagementSearchFormLocNames =
	| `${LocNameStart}LabelSearch`
	| `${LocNameStart}LabelCmcId`
	| `${LocNameStart}LabelExternalId`
	| `${LocNameStart}LabelFor`
	| `${LocNameStart}ButtonSearchToDelete`
	| `${LocNameStart}ButtonSearch`
	| `${LocNameStart}ErrorSearchTypeRequired`
	| `${LocNameStart}ErrorSearchParamRequired`
	| `${LocNameStart}ErrorSearchParamPattern`
	| `${LocNameStart}ErrorMaxCmcId`;

export const spCredlyManagementSearchFormLocs: LocDefs<SPCredlyManagementSearchFormLocNames> = {
	SPCredlyManagementSearchFormLabelSearch: {
		defaultValue: 'Search',
		description: 'Label for: Search.',
		displayPath: `${pathStart}Search`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldLabel.Search',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormLabelCmcId: {
		defaultValue: 'CMC ID',
		description: 'Label for: CMC ID.',
		displayPath: `${pathStart}CMC ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldLabel.CmcId',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormLabelExternalId: {
		defaultValue: 'Client ID',
		description: 'Label for: Client ID.',
		displayPath: `${pathStart}Client ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldLabel.externalId',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormLabelFor: {
		defaultValue: 'For',
		description: 'Label for: For.',
		displayPath: `${pathStart}For`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldLabel.For',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormButtonSearchToDelete: {
		defaultValue: 'Search to delete',
		description: 'Search to delete button',
		displayPath: `${pathStart}Search to delete`,
		displayType: 'Button',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Button.SearchToDelete',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormButtonSearch: {
		defaultValue: 'Search',
		description: 'Search button',
		displayPath: `${pathStart}Search`,
		displayType: 'Button',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Button.Search',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormErrorSearchTypeRequired: {
		defaultValue: 'Selection of a search type is required.',
		description: 'Search type required error message',
		displayPath: `${pathStart}Search Type Required`,
		displayType: 'Error',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldError.SearchTypeRequired',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormErrorMaxCmcId: {
		defaultValue: 'CMC ID must be positive number less than 2147483647.',
		description: 'CMC ID max error message',
		displayPath: `${pathStart}CMC ID Max Error`,
		displayType: 'Error',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldError.MaxCmcId',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormErrorSearchParamPattern: {
		defaultValue: 'This is not a valid ID for the selected search type.',
		description: 'Search param pattern error message',
		displayPath: `${pathStart}Search Param Pattern Error`,
		displayType: 'Error',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldError.SearchParamPattern',
		...sharedProperties,
	},
	SPCredlyManagementSearchFormErrorSearchParamRequired: {
		defaultValue: 'A valid ID for search of the selected type is required.',
		description: 'Search param required error message',
		displayPath: `${pathStart}Search Param Required`,
		displayType: 'Error',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.FieldError.SearchParamRequired',
		...sharedProperties,
	},
};

export type SPCredlyManagementSearchFormLocType = LocMap<SPCredlyManagementSearchFormLocNames>;
